module.exports = {"511803100":"蒙阳镇","511803101":"百丈镇","511803102":"车岭镇","511803103":"永兴镇","511803104":"马岭镇","511803105":"新店镇","511803106":"蒙顶山镇","511803107":"黑竹镇","511803108":"红星镇","511803200":"城东乡","511803201":"前进乡","511803202":"中峰乡","511803203":"联江乡","511803204":"廖场乡","511803205":"万古乡","511803206":"红岩乡","511803207":"双河乡","511803208":"建山乡","511803209":"解放乡","511803210":"茅河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511803.json
// module id = 2381
// module chunks = 0